import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import Motion from '@/app/components/Motion';

export const SinglesDayHeroBackground = () => {
  return (
    <Motion
      className="relative z-10 h-full"
      animate={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 1.1 }}
      transition={{ duration: 1.5, type: 'tween' }}
      data-cy="singles-day-hero-background"
    >
      <ArtDirectionImage
        className="object-cover"
        fill
        localizedAlt="singles_day_alt_text"
        priority
        sizes="100vw"
        srcSet={[
          {
            media: '(max-width: 767px)',
            src: 'singles_day_mobile.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.6&fp-z=1.3',
          },
          {
            media: '(min-width: 767px)',
            src: 'singles_day_mobile.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.38&fp-y=0.52&fp-z=1.6',
          },
        ]}
      />
    </Motion>
  );
};
